<template>
  <div >
  <Form ref="userForm" :model="data" :label-width="70" :rules="ruleData" class="user-detail">
      <FormItem label="工号" prop="">
          {{data.job_number}} <Button size="small" @click="updateJobNumber(data.department_id)">更新工号</Button>
      </FormItem>
      <FormItem label="部门" prop="department_id">
        <Cascader :data="$store.state.department" v-model="data.department_id" @on-change="depChange" change-on-select></Cascader>
      </FormItem>
      <FormItem label="角色" v-if="$store.state.userInfo.role!=5&&$store.state.userInfo.role!=2">
        <Select v-model="data.role">
          <Option :value="0">公司领导</Option>
          <Option :value="1">部门主管</Option>
          <Option :value="2">项目经理</Option>
          <Option :value="3">财务管理</Option>
          <Option :value="4">人事管理</Option>
          <Option :value="5">普通员工</Option>
          <Option :value="6">行政主管</Option>
          <Option :value="7">出纳</Option>
        </Select>
      </FormItem>
      <FormItem label="分管部门" v-if="$store.state.userInfo.role!=5&&$store.state.userInfo.role!=2&&data.role!=2&&data.role!=5&&data.role!=4">
        <Tag v-for="(item,ind) in departmentGroup" :key="ind" :name="ind" closable @on-close="handleDelDep(item)">
          {{item | formatLabel}}
        </Tag>
        <Poptip placement="bottom-start" width="400">
          <Button icon="ios-plus-empty" type="dashed" size="small" @click="handleAdd(false)">添加</Button>
          <div slot="title">选择部门</div>
          <div class="api" slot="content">
            <CheckboxGroup v-model="departmentGroup">
              <Row>
                <template v-for="(item, ind) in $store.state.department">
                <Col :span="12" v-if="item.pid==1 && item.status==1" :key="ind" :style="isProject?'height:220px;':''">
                  <Tag style="display:block;height:auto;" :key="ind">
                    <Checkbox :label="JSON.stringify(item)" style="display:block;padding:5px 0">{{item.label}}</Checkbox>
                  </Tag>
                </Col>
                </template>
              </Row>
            </CheckboxGroup>
          </div>
        </Poptip>
      </FormItem>
      <FormItem label="分管项目" v-if="$store.state.userInfo.role!=5&&data.role!=5&&data.role!=4">
        <Tag v-for="(item,ind) in projectGroup" :key="ind" :name="ind" closable @on-close="handleDelPro(item)">
          {{item | formatLabel}}
        </Tag>
        <Poptip placement="bottom-start" width="600">
        <Button icon="ios-plus-empty" type="dashed" size="small" @click="handleAdd(true)">添加</Button>
        <div slot="title">选择项目组</div>
          <div class="api" slot="content" style="height:400px;overflow: auto">
            <CheckboxGroup v-model="projectGroup">
              <Row>
                <template v-for="(item, ind) in $store.state.department">
                <Col :span="12" v-if="item.pid==1 && item.status==1" :key="ind">
                  <h4 style="margin-bottom:10px;border-bottom:1px solid #ddd;padding-bottom:10px;" :key="'h4_'+ind">
                    {{item.label}}
                  </h4>
                  <div style="padding-left:15px;" :key="'div_'+ind">
                    <p v-for="(child, key) in item.children" :key="key" style="margin-bottom:5px">
                      <Checkbox :label="JSON.stringify(child)">{{child.label}}</Checkbox>
                    </p>
                  </div>
                </Col>
                </template>
              </Row>
            </CheckboxGroup>
          </div>
        </Poptip>
      </FormItem>
      <FormItem label="手机号" prop="mobile">
        <Input v-model="data.mobile" :disabled="!$store.state.isSuperUser && data.id > 0">
        <!-- <template  v-if="data.id>0"> -->
          <!-- <span slot="append">
            {{data.wx_token?'已经绑定微信':'未绑定微信'}}
          </span> -->
        <!-- </template> -->
        </Input>
      </FormItem>
      <FormItem label="姓名" prop="username">
        <Input v-model="data.username"></Input>
      </FormItem>
      <template  v-if="data.id==0">
        <FormItem label="密码" prop="password">
          <Input v-model="data.password"></Input>
        </FormItem>
      </template>
      <FormItem label="性别">
        <RadioGroup v-model="data.gender">
          <Radio :label="1">男</Radio>
          <Radio :label="0">女</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="昵称" prop="nickname">
        <Input v-model="data.nickname"></Input>
      </FormItem>
      <FormItem label="E-mail" prop="email">
        <Input v-model="data.email" type="email"></Input>
      </FormItem>
      <FormItem label="简介">
        <Input v-model="data.bio" type="textarea"></Input>
      </FormItem>
      <FormItem label="权限组" v-if="isEditGroups">
        <Select v-model="data.group_id" style="width:200px">
          <Option :value="0" :key="0">未分配</Option>
          <Option v-for="item in groupData" :value="item.id" :key="item.id">{{ item.title }}</Option>
        </Select>
        <Tag>设置为[未分配]该用户将无法登录</Tag>
      </FormItem>
      <FormItem label="当前状态">
        <Select v-model="data.status" style="width:200px">
          <Option v-for="item in $store.state.stateInfo" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <Tag>设置为[待审核，离职，禁用]都将导致用户无法登录</Tag>
      </FormItem>
      <FormItem label="更新时间" v-if="data.id>0">
        <Tag>{{formatTime(data.updated_at)}}</Tag>
      </FormItem>
      <FormItem label="">
        <Button type="primary" @click="submitUser('userForm')" :disabled="!this.$menu.isPower('user', 'edit')" size="large">{{data.id>0?'修改资料':'添加用户'}}</Button>
      </FormItem>
  </Form>
  <Modal
    v-model="selectDepartment"
    title="选择部门"
    width="90%"
    @on-ok="selectOk">

  </Modal>

</div>
</template>

<script>
import {fetch, put, post} from '../fetch/api'
import * as filter from '../util/filter'
import validate from '../util/validateForm'

export default {
  name: 'UserEdit',
  props: {
    userId: null,
    data: {
      type: Object
    },
    change: {
      type: Function
    },
    update: {
      type: Function
    }
  },
  data () {
    const checkPhone = (rule, value, callback) => {
      let res = validate.phone(value)
      if (res !== true) {
        callback(new Error(res))
      } else {
        callback()
      }
    }
    const syncCheckMobile = (rule, value, callback) => {
      if (this.data.id > 0) {
        callback()
      } else {
        fetch('check/users/mobile/' + value + '?uid=' + this.data.id).then(res => {
          if (res) {
            callback(new Error('手机号码已经存在'))
          } else {
            callback()
          }
        }).catch(() => {
          callback(new Error('验证失败请重试！'))
        })
      }
    }
    // const syncCheckNickname = (rule, value, callback) => {
    //   if (this.data.id > 0) {
    //     callback()
    //   } else {
    //     fetch('check/users/nickname/' + value + '?uid=' + this.data.id).then(res => {
    //       if (res) {
    //         callback(new Error('昵称已经存在'))
    //       } else {
    //         callback()
    //       }
    //     }).catch(() => {
    //       callback(new Error('验证失败请重试！'))
    //     })
    //   }
    // }
    const syncCheckEmail = (rule, value, callback) => {
      if (this.data.id > 0) {
        callback()
      } else {
        fetch('check/users/email/' + value + '?uid=' + this.data.id).then(res => {
          if (res) {
            callback(new Error('邮箱地址已经存在'))
          } else {
            callback()
          }
        }).catch(() => {
          callback(new Error('验证失败请重试！'))
        })
      }
    }
    return {
      departmentGroup: [],
      departmentGroupIds: '',
      projectGroup: [],
      projectGroupIds: '',
      isProject: false,
      isEditGroups: false,
      selectDepartment: false,
      groupData: [],
      departmentData: [],
      ruleData: {
        department_id: [
          {required: true, type: 'array', message: '请选择部门', trigger: 'blur'}
        ],
        role: [
          {required: true, message: '请选择角色', trigger: 'change'}
        ],
        mobile: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {validator: checkPhone, trigger: 'blur'},
          {validator: syncCheckMobile, trigger: 'blur'}
        ],
        username: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        nickname: [
          // {required: true, message: '请输入昵称', trigger: 'blur'},
          // {validator: syncCheckNickname, trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'change'},
          { type: 'email', message: '邮箱地址格式错误', trigger: 'blur' },
          {validator: syncCheckEmail, trigger: 'blur'}
        ],
        password: [
          {required: true, min: 6, message: '请输入密码，必须大于6个字符！', trigger: 'blur'}
        ]
      },
      userStatusText: [
        {'label': '待审核', value: 0},
        {'label': '在职', value: 1},
        {'label': '离职', value: 2},
        {'label': '禁用', value: 3}
      ]
    }
  },
  watch: {
    data () {
      for (let k in this.$store.state.department) {
        let item = this.$store.state.department[k]
        let id = item.value
        if (this.data.department_group) {
          let ids = this.data.department_group.split(',')

          if (ids.indexOf(String(id)) >= 0) this.departmentGroup.push(JSON.stringify(item))
        }
        if (this.data.project_group) {
          for (let i in item.children) {
            let child = item.children[i]
            let childId = child.value
            let childIds = this.data.project_group.split(',')
            if (childIds.indexOf(String(childId)) >= 0) this.projectGroup.push(JSON.stringify(child))
          }
        }
      }
    },
    departmentGroup (val) {
      let ids = []
      for (let k in val) {
        let json = JSON.parse(val[k])
        ids.push(json.value)
      }
      this.departmentGroupIds = ids.join(',')
    },
    projectGroup (val) {
      let ids = []
      for (let k in val) {
        let json = JSON.parse(val[k])
        ids.push(json.value)
      }
      this.projectGroupIds = ids.join(',')
    }
  },
  filters: {
    formatLabel (val) {
      let json = JSON.parse(val)
      return json.label
    }
  },
  mounted () {
    this.fetchGroups()
    this.fetchDepartment()
    this.isEditGroups = this.$menu.isPower('group', 'edit')
  },
  methods: {
    selectOk () {

    },
    handleAdd (type) {
      this.isProject = type
      // this.selectDepartment = true
    },
    handleDelDep (item) {
      const index = this.departmentGroup.indexOf(item)
      this.departmentGroup.splice(index, 1)
    },
    handleDelPro (item) {
      const index = this.projectGroup.indexOf(item)
      this.projectGroup.splice(index, 1)
    },
    formatTime (time) {
      return filter.formatDate(time)
    },
    fetchGroups () {
      fetch('console/groups/0').then(res => {
        this.groupData = res
      })
    },
    fetchDepartment () {
      this.$store.dispatch('setDepartment', false)
    },
    depChange (val) {
      this.$emit('change', val)
    },
    updateJobNumber (val) {
      this.$emit('update', val)
    },
    submitUser (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.data['password'] = ''
          let data = JSON.parse(JSON.stringify(this.data))
          let res
          data.department_id = JSON.stringify(data.department_id)
          data.department_group = this.departmentGroupIds
          data.project_group = this.projectGroupIds
          if (data.id === 0) {
            res = post(`/users/add`, data)
          } else {
            res = put(`/users/edit`, data)
          }
          res.then(res => {
            if (res.status === 'ok') {
              this.$Message.success(data.id === 0 ? '添加成功' : '编辑成功')
              // this.data = JSON.parse(JSON.stringify(formData))
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 5
              })
            }
          })
          .catch(() => {
            this.$Message.error(res.msg)
          })
        } else {
          this.$Message.error('请确认表单是否填写完整')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mgui-alert{
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1010
  }
  .mgui-alert-inner{
    width: 200px;
    position: absolute;
    top: 0;
    right: 0;
    z-index:1011;
  }
  .mgui-alert-item{
    width: 200px;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    position: relative;
    right: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4)
  }
  .mgui-alert-item h2{
    font-size: 12px;
    color: #f00;
    margin-bottom: 5px;
  }
  .mgui-alert-item p{
    font-size: 14px;
    margin: 0;
  }
  .mgui-alert-item {
    transition: all 1s;
    display: block;
    margin-bottom: 10px;
  }
  .mgui-alert-enter, .mgui-alert-leave-to
  /* .mgui-alert-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(100%);
  }
  .mgui-alert-leave-active {
    position: absolute;
  }

  .mgui-alert-close{
    position: absolute;
    right: 10px;
    top: 10px;
    transition: .5s 0s all ease;
    -webkit-transition: .5s 0s all ease;
  }
  .mgui-alert-close:hover{
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  /*.bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }*/
</style>
